'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { ListboxButton } from './listbox-button.component.js';
import { ListboxList } from './listbox-list.component.js';
import { ListboxPopover } from './listbox-popover.component.js';
import { Listbox } from './listbox.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const BasicListbox = renderWithRef('BasicListbox', null, (t, l)=>{
    let { children: p, inModal: b = false, darkMode: a, bgc: s, backgroundColor: u, 'aria-label': f, 'aria-labelledby': y } = t, O = _object_without_properties(t, [
        "children",
        "inModal",
        "darkMode",
        "bgc",
        "backgroundColor",
        'aria-label',
        'aria-labelledby'
    ]), j = s || u;
    return jsxs(Listbox, _object_spread_props(_object_spread({
        darkMode: a,
        bgc: j
    }, O), {
        ref: l,
        children: [
            jsx(ListboxButton, {
                "aria-label": f,
                "aria-labelledby": y
            }),
            jsx(ListboxPopover, {
                darkMode: a,
                bgc: j,
                inModal: b,
                children: jsx(ListboxList, {
                    children: p
                })
            })
        ]
    }));
});

export { BasicListbox };
